<template>
  <div class="flex items-center gap-12">
    <div
      ref="container"
      class="scrollbar-none -mx-24 flex min-w-0 flex-nowrap gap-8 overflow-x-auto snap-x snap-mandatory px-24 scroll-pl-24 lg:-mx-32 lg:px-32 lg:scroll-pl-32"
      :class="maskClass"
    >
      <RevButtonBase
        v-for="(link, index) in links"
        :key="link.relativeLink"
        class="bg-action-default-mid hover:bg-action-default-mid-hover text-action-default-hi body-2 flex h-36 w-fit shrink-0 items-center rounded-full px-12 snap-start"
        :to="link.relativeLink"
        @click="trackFacetLinkClick(link, index)"
      >
        {{ link.title }}
      </RevButtonBase>
    </div>
    <div
      v-if="hasLeftScroll || hasRightScroll"
      class="hidden gap-12 shrink-0 items-center ml-12 pl-12 [@media(pointer:fine)]:flex"
    >
      <RevButtonIcon
        :aria-label="i18n(translations.scrollLeft)"
        :disabled="!hasLeftScroll"
        :icon="IconChevronLeft"
        variant="primary"
        @click="scrollToPrev"
      />
      <RevButtonIcon
        :aria-label="i18n(translations.scrollRight)"
        :disabled="!hasRightScroll"
        :icon="IconChevronRight"
        variant="primary"
        @click="scrollToNext"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { nextTick, useTemplateRef, watch } from 'vue'

import { useFilterTracking } from '@backmarket/nuxt-layer-recommendation/filtering/useFilterTracking'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import type { LinkBooster } from '~~/shared/api/internal-links/types'

import { useScrollMaskClass } from '../../composables/useScrollMaskClass'

import translations from './FacetsFilters.translations'

const props = defineProps<{
  links: LinkBooster[]
}>()

const i18n = useI18n()
const { trackFilterClick } = useFilterTracking()

const container = useTemplateRef<HTMLDivElement>('container')
const {
  maskClass,
  onScrollAreaChange,
  hasLeftScroll,
  hasRightScroll,
  scrollToNext,
  scrollToPrev,
} = useScrollMaskClass(container)

function trackFacetLinkClick(link: LinkBooster, index: number) {
  trackFilterClick({
    zone: 'filter',
    name: 'Quick Filters',
    value: link.title,
    position: index + 1,
  })
}

watch(
  () => props.links,
  () => nextTick(onScrollAreaChange),
)
</script>
